import styled from 'styled-components';
import { Checkbox, Flex, TimePicker, Upload } from 'antd';
export const SiteOnBoardCard = styled.div `
  display: flex;
  flex-flow: column;
  align-items: stretch;
  width: calc(700px + calc(calc(5 * 1px) * 4) * 2);
  height: max-content;
  min-height: 530px;
  box-sizing: border-box;
  max-width: 100%;
  padding-left: calc(calc(5 * 1px) * 4);
  padding-right: calc(calc(5 * 1px) * 4);
  &:last-of-type {
    padding-bottom: calc(calc(5 * 1px) * 4);
  }
  &:first-of-type {
    padding-top: calc(calc(5 * 1px) * 4);
  }
`;
export const SiteOnBoardCardHeader = styled.div `
  display: block;
  position: relative;
  padding: 0 calc(calc(5 * 1px) * 4) calc(calc(5 * 1px) * 4);
  > * {
    font-size: calc(calc(14px - 2px) * 2);
    font-weight: 500;
    color: hsla(0, 0%, 33.33%, 1);
    margin: 0;
  }
  h3 {
  }
`;
export const SiteOnBoardCardHeaderProgress = styled.div `
  position: absolute;
  bottom: 100%;
  right: 0;
  left: 0;

  left: calc(calc(5 * 1px) * 2);
  right: calc(calc(5 * 1px) * 2);
  /* padding: calc(calc(5 * 1px) + 1px)
    calc(5 * 1px); */
  background: hsla(0, 0%, 0%, 0.07);
  border-radius: 15px 15px 0 0;
  font-size: calc(14px - 2px);
  line-height: 14px;
  max-height: 10px;
  color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
  text-align: center;
  overflow: hidden;
  .bc-progress {
    --bc-progress-line-border-radius: 0;

    --bc-progress-default-color: hsla(129, 60%, 50%, 1);
    --bc-progress-remaining-color: rgba(0, 0, 0, 0);
  }
  .bc-progress-bg.bc-progress-bg-outer {
    height: 22px !important;
  }
  .bc-progress-text {
    display: none;
  }
`;
export const SiteOnBoardCardContent = styled.div `
  position: relative;
  min-height: 530px;
  display: flex;
  flex-direction: column;
  padding: calc(5 * 1px) 0 !important;

  &:not(.no-background) {
    padding: 0;
    border-radius: calc(15px * 4 / 3);
    box-shadow: 0 8px 10px -6px hsla(0, 0%, 0%, 0.1), 0 15px 35px -5px hsla(0, 0%, 0%, 0.1),
      0 0 0 1px hsla(0, 0%, 0%, 0.07);
    background-color: hsla(
      var(--ue-option-panel-background-color_h, 0),
      var(--ue-option-panel-background-color_s, 0%),
      var(--ue-option-panel-background-color_l, 100%),
      var(--ue-option-panel-background-color_t, 1)
    );
    box-sizing: border-box;
  }
`;
export const SiteOnBoardCardBolck = styled.div `
  display: block;
  padding: calc(calc(5 * 1px) * 3) calc(calc(5 * 1px) * 4);
  &:not(.no-divider) {
    border-top: 1px solid hsla(0, 0%, 0%, 0.07);
  }
`;
export const StepItemRow = styled.div `
  display: block;
  font-size: 14px;
  line-height: calc(14px + 6px);
  color: hsla(0, 0%, 33.33%, 1);
  &:not(:last-of-type) {
    margin-bottom: calc(calc(5 * 1px) * 3);
  }
`;
export const StepItemRowInner = styled.div `
  display: flex;
  align-items: flex-start;
`;
export const StepItemRowHeader = styled.div `
  display: block;
  padding-right: calc(calc(5 * 1px) * 4);
  font-size: 14px;
  line-height: calc(14px + 6px);
  color: hsla(0, 0%, 33.33%, 1);
  width: 45%;
  box-sizing: border-box;
  label {
    display: inline-block;
    padding-top: calc(calc(5 * 1px) * 2);
  }
`;
export const StepItemRowContent = styled.div `
  min-height: 100%;
  align-self: stretch;
  font-size: 14px;
  line-height: calc(14px + 6px);
  color: hsla(0, 0%, 33.33%, 1);
  width: 55%;
  box-sizing: border-box;
`;
// export const SiteOnBoardingCard = styled.div`
//   display: inline-block;
//   position: relative;
//   border-radius: 15px;
//   box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
//   background-color: hsla(0, 0%, 100%, 1);
//   color: hsla(0, 0%, 33.33%, 1);
//   box-sizing: border-box;
//   width: 100%;
//   margin-bottom: calc(calc(5 * 1px) * 2 + 14px);
// `;
// export const SiteOnBoardingCardHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   padding: calc(calc(5 * 1px) * 3) calc(calc(5 * 1px) * 4)
//     calc(calc(5 * 1px) * 3) calc(calc(5 * 1px) * 3);
//   border-bottom: 1px solid hsla(0, 0%, 0%, 0.07);
// `;
// export const SiteOnBoardingCardBody = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   gap: calc(calc(5 * 1px) * 2);
//   padding: calc(calc(5 * 1px) * 3);
// `;
export const StepWrapper = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
`;
export const StepHead = styled.div `
  margin-bottom: ${({ theme }) => theme.space.space400};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  h1 {
    margin: 0;
    text-align: inherit;
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-weight: 700;
    @media (min-width: 768px) {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
`;
export const StepContent = styled.div `
  flex: 2 1;
  display: flex;
  flex-direction: column;
`;
export const StyledInfoText = styled.div `
  color: ${(props) => (props.hasError ? 'red' : 'black')};
  font-size: 14px;
  margin-top: 4px;
`;
export const StepBody = styled.div `
  height: 100%;
`;
export const StepAction = styled.div `
  margin-top: ${({ theme }) => theme.space.space500};
`;
export const FileUploader = styled(Upload) ``;
export const UploadArea = styled.div `
  min-width: 363px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  border-radius: 15px;
  border: 2px dashed hsla(0, 0%, 33.33%, calc(1 - 0.6));
  &:not(.preview) {
    padding: calc(calc(5 * 1px) * 4);
    overflow: hidden;
  }
  transition: all 0.2s linear;
  box-sizing: border-box;
  height: 165px;
  cursor: pointer;

  span {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    height: calc(calc(5 * 1px) * 4);
    width: calc(calc(5 * 1px) * 4);
    min-width: calc(calc(5 * 1px) * 4);
    color: hsla(0, 0%, 33.33%, calc(1 - 0.2));
    height: calc(calc(calc(5 * 1px) * 4) * 2);
    width: calc(calc(calc(5 * 1px) * 4) * 2);
    transition: all 0.2s linear;
  }
  h5 {
    text-align: center;
    font-size: 14px;
    line-height: calc(14px + 6px);
    color: #545454;
    margin: 0;
    margin-top: calc(5 * 1px);
    margin-bottom: calc(5 * 1px);
  }
  p {
    text-align: center;
    font-size: calc(14px - 2px);
    line-height: 14px;
    color: hsla(0, 0%, 33.33%, calc(1 - 0.15));
    margin: 0;
  }
  .bc-skeleton.bc-skeleton-element {
    flex: 1;
  }
`;
export const UploadAreaPreview = styled.div `
  position: relative;
`;
export const UploadAreaPreviewImage = styled.div `
  box-shadow: inset 0 0 0 2px hsla(0, 0%, 0%, 0.07);
  background-position: 0px 3px, 10px 13px;
  background-size: 20px 20px;
  background-repeat: repeat;
  background-image: linear-gradient(
      45deg,
      hsla(0, 0%, 0%, 0.07) 25%,
      transparent 0,
      transparent 75%,
      hsla(0, 0%, 0%, 0.07) 0
    ),
    linear-gradient(45deg, hsla(0, 0%, 0%, 0.07) 25%, transparent 0, transparent 75%, hsla(0, 0%, 0%, 0.07) 0);
  background-color: transparent;
  height: 165px;
  display: flex;
  align-content: center;
  justify-content: center;
  border-radius: calc(15px * 2 / 3);
  overflow: hidden;

  &:before,
  &:after {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 2px;
    box-shadow: inset 0 0 0 2px hsla(0, 0%, 0%, 0.07);
  }
  &:before {
    top: 0;
  }
  &::after {
    bottom: 0;
  }

  img {
    position: relative;
    cursor: pointer;
  }
`;
export const FileUploadAction = styled.div `
  display: inline-flex;
  border-radius: 15px;
  padding: 2px;
  background-color: hsla(0, 0%, 0%, 0.07);
  box-sizing: border-box;
  vertical-align: middle;
  max-width: 100%;
  margin-left: auto;
  & > *:not(:last-of-type)button {
    background-color: transparent;
    margin: calc(2px * -1) 0 calc(2px * -1) calc(2px * -1);
  }
  & > *:not(:last-of-type)button,
  & > *:not(:last-of-type)button {
    border-top-right-radius: calc(15px / 3);
    border-bottom-right-radius: calc(15px / 3);
    .bc-btn-inner-wrapper {
      border-top-right-radius: calc(15px / 3);
      border-bottom-right-radius: calc(15px / 3);
    }
  }
  button {
    display: inline-flex;
    position: relative;
    vertical-align: middle;
    border: none;
    border-radius: 15px;
    padding: 2px;
    max-width: 100%;
    cursor: pointer;
    background-color: hsla(0, 0%, 0%, 0.07);
    color: hsla(0, 0%, 33.33%, 1);

    user-select: none;
    -webkit-user-drag: none;
    touch-action: none;
    -webkit-tap-highlight-color: transparent;
    .bc-btn-inner-wrapper {
      background-color: hsla(0, 0%, 100%, 1);
    }
  }
`;
export const SiteIconPreview = styled(Flex) `
  img {
  }
`;
export const SiteIconPreviewItem = styled.span `
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  color: hsla(0, 0%, 33.33%, calc(1 - 0.6));
  width: 96px;
  height: 96px;
  border-radius: 39px;
  background-color: hsla(0, 0%, 0%, 0.07);
  cursor: pointer;
`;
export const WeekWrapper = styled.div `
  justify-content: space-between;
  align-items: center;
  gap: 1.0156rem;
  width: 100%;
  display: flex;
`;
export const SingleWeek = styled(Checkbox) `
  display: flex !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;

  box-shadow: none;

  /* color: ${({ theme }) => theme.colors.dark};
  border-color: ${({ theme }) => theme.colors.dark};
  background-color: rgba(0, 0, 0, 0); */

  /* border-width: 1px; */
  /* border-style: dashed; */

  /* border: 1px dashed ${({ theme }) => theme.colors.gray300}; */

  font-size: 14px;
  line-height: calc(14px + 4px);
  --bc-color-text: hsla(0, 0%, 33.33%, 1);
  color: var(--bc-color-text);
  font-size: 14px;
  line-height: calc(14px + 4px);
  background-color: hsla(0, 0%, 0%, 0.07);

  /* Disabled state styling */
  ${({ disabled, theme }) => disabled &&
    `
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: auto;
    --bc-color-fill-tertiary: hsla(
      0,
      0%,
      0%,
      0.07
    );
  `}

  justify-content: center;
  align-items: center;
  outline: 0 !important;
  position: relative;

  .bc-checkbox-inner {
    display: none;
  }

  .bc-checkbox {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 50% !important;
  }

  &.bc-checkbox-wrapper-checked:not(.bc-checkbox-wrapper-disabled):hover,
  &.bc-checkbox-wrapper-checked:not(.bc-checkbox-disabled) {
    --bc-color-text: ${({ theme }) => theme.colors.white};
    /* border-color: ${({ theme }) => theme.colors.dark}; */
    background-color: hsla(129, 60%, 50%, 1);
    .bc-checkbox {
    }
    /* background-color: ${({ theme }) => theme.colors.dark}; */
  }
`;
export const TimePickers = styled(TimePicker.RangePicker) `
  --bc-control-height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: hsla(0, 0%, 33.33%, 1) !important;
  appearance: none;
  background-color: hsla(0, 0%, 0%, 0.07);
  --bc-font-family: 14px;

  background-clip: padding-box;
  --bc-color-border: transparent;
  border-radius: 15px;
  box-shadow: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  line-height: 1.25;

  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;
export const HourSec = styled.div `
  /* display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${({ theme }) => theme.colors.gray400};
  border-radius: ${({ theme }) => theme.borders.radius.lg};
  padding: ${({ theme }) => theme.space.space500};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.space100}; */

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: calc(calc(5 * 1px) * 2);
  padding: calc(calc(5 * 1px) * 3);
  box-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
  margin: 1px;
  border-radius: calc(calc(5 * 1px) * 3);
  min-height: calc(14px * 1.1);
  font-size: 14px;
  line-height: normal;
  color: hsla(0, 0%, 33.33%, 1);
`;
export const SiteAddressWrapper = styled.div `
  height: 450px;
  width: 100%;
  border-top-left-radius: calc(15px * 4 / 3);
  border-top-right-radius: calc(15px * 4 / 3);
  position: relative;
  overflow: hidden;
  padding: 10px;
  /* padding: ${({ theme }) => theme.space.space400}; */

  .selct-wrapper {
    position: relative;
    border-radius: 20px;
    box-shadow: 0 8px 10px -6px hsla(0, 0%, 0%, 0.1), 0 15px 35px -5px hsla(0, 0%, 0%, 0.1),
      0 0 0 1px hsla(0, 0%, 0%, 0.07);
    background-color: hsla(
      var(--ue-option-panel-background-color_h, 0),
      var(--ue-option-panel-background-color_s, 0%),
      var(--ue-option-panel-background-color_l, 100%),
      var(--ue-option-panel-background-color_t, 1)
    );
    box-sizing: border-box;
    padding: 6px;
  }
`;
export const SiteAddressMap = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &::after {
    content: '';
    opacity: 0.3;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;
